import React from 'react';
import {
  EAutocompleteOption,
  EndAdornmentIconWrapper,
  ETooltip,
} from 'webapp-lib/Components';

import {TranslatedLocale} from '@lexian/api/support-api';
import {ViewOff} from '_/assets/images';
import i18n from '_/i18n';

type ActivatableItem = {
  active: boolean;
};

export const filterActiveItems = <I extends ActivatableItem>(items: I[]): I[] =>
  items.filter((item) => item.active);

type TranslatedItem = {
  id: string;
  translatedName: string;
};

export const getTranslatedName = (
  items: TranslatedItem[],
  id: string | undefined
): string | undefined => items.find((item) => item.id === id)?.translatedName;

export const getOptions = <I extends TranslatedActivatableItem>(
  items: I[],
  textField?: Extract<keyof I, string>,
  categoryField?: Extract<keyof I, string>
): EAutocompleteOption[] =>
  items.map((item) => ({
    displayText: textField ? (item[textField] as string) : item.translatedName,
    value: item.id,
    categoryName: categoryField ? (item[categoryField] as string) : undefined,
    endAdornment: !item.active ? (
      <ETooltip title={i18n.t('common:labels.status.inactive')}>
        <EndAdornmentIconWrapper>
          <ViewOff />
        </EndAdornmentIconWrapper>
      </ETooltip>
    ) : undefined,
  }));

export type TranslatedActivatableItem = TranslatedItem & ActivatableItem;

export const getActiveOptions = (
  items: TranslatedActivatableItem[]
): EAutocompleteOption[] => getOptions(filterActiveItems(items));

export const getLocaleOptions = (
  translatedLocales: TranslatedLocale[]
): EAutocompleteOption[] =>
  translatedLocales.map((locale) => ({
    value: locale.locale,
    displayText: locale.translatedName,
  }));

export const getTranslatedLocaleName = (
  translatedLocales: TranslatedLocale[],
  locale: string | undefined
): string | undefined =>
  translatedLocales.find((lang) => lang.locale === locale)?.translatedName;
